
import MotionScroll from '../../assets/scripts/motionScroll'

export default {
  props: {
    images: { type: Array, default: () => ([]) },
    interactive: { type: Boolean, default: true },
  },

  data() {
    return {
      targetScroll: 0,
      isStart: true,
      isEnd: false,
    }
  },

  mounted() {
    this.scroll = new MotionScroll(this.$refs.scroller)
    this.$refs.scroller.addEventListener('scroll', this.scrollHandler, { passive: true })
  },

  beforeDestroy() {
    this.scroll.destroy()
    this.$refs.scroller.removeEventListener('scroll', this.scrollHandler, { passive: true })
  },

  methods: {
    scrollHandler() {
      this.isStart = this.$refs.scroller.scrollLeft < 5
      this.isEnd = this.$refs.scroller.scrollLeft > this.$refs.scroller.scrollWidth - this.$refs.scroller.offsetWidth - 5
    },

    previous() {
      this.scroll.previous()
    },

    next() {
      this.scroll.next()
    },
  }
}
